import { Link } from "react-router-dom";
import logo from "../assets/logolime.jpg"
import FaceBookLogo from "../assets/svg/FaceLogo";
import Xlogo from "../assets/svg/Xlogo";
import InstaLogo from "../assets/svg/IstaLogo";


export default function Footer() {
    return (
        <footer className="footer">
            <div className="container footer-inner">
                <div className="footer-col">
                    <div className="brand footer-brand">
                        <img src={logo} alt="logo image" className="logo" aria-hidden />
                        <span className="brand-name">LimeTime</span>
                    </div>
                    <p className="muted">
                        Lime Time is a comprehensive attendance and employee management solution designed
                        to streamline the workforce.
                    </p>
                    <div className="socials">
                        <a href="/" aria-label="Facebook" className="social-dot" ><FaceBookLogo/></a>
                        <a href="/" aria-label="Twitter" className="social-dot" ><Xlogo/></a>
                        <a href="/" aria-label="Instagram" className="social-dot"><InstaLogo/></a>
                    </div>
                </div>

                <div className="footer-col">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="https://www.limeti.me/">Home</a></li>
                        <li><a href="https://www.limeti.me/#Why-Choose">Why Choose us</a></li>
                        <li><a href="https://www.limeti.me/contact-us">Contact</a></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Contact Us</h4>
                    <ul>
                        <li>Call us: +1-265-555-2840</li>
                        <li>Mail us: info@limeTi.com</li>
                        {/* <li>Visit Us: Your Address here</li> */}
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container muted">© {new Date().getFullYear()} LimeTime</div>
            </div>
        </footer>
    );
}